export type CookieConsent = "accepted" | "rejected";

const COOKIE_CONSENT_KEY = "cookie-consent";

export function getCookieConsent(): CookieConsent | null {
	try {
		const raw = window.localStorage.getItem(COOKIE_CONSENT_KEY);
		return raw === "accepted" || raw === "rejected" ? raw : null;
	} catch {
		return null;
	}
}

export function setCookieConsent(consent: CookieConsent) {
	try {
		window.localStorage.setItem(COOKIE_CONSENT_KEY, consent);
	} catch {
		// Ignore storage failures.
	}
}
